module.exports = __webpack_public_path__ + "static/media/delta_heatmap_1.cdf7c4ed.png";